import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLazyLoadQuery } from "react-relay";
import { permissionBasedNavigation_featureToggles_Query } from "@relay/permissionBasedNavigation_featureToggles_Query.graphql";
import { FEATURE_TOGGLES_QUERY } from "./permission-based-navigation.graphql";
import { setActiveFeatureToggles } from "../store/slices/FeatureTogglesSlice";

export const PermissionBasedNavigationFeatureToggles = () => {
	const dispatch = useDispatch();
	const query = useLazyLoadQuery<permissionBasedNavigation_featureToggles_Query>(
		FEATURE_TOGGLES_QUERY,
		{},
	);
	useEffect(() => {
		if (query.FeatureToggle.activeFeatureToggles) {
			dispatch(setActiveFeatureToggles(query.FeatureToggle.activeFeatureToggles));
		}
	}, [query?.FeatureToggle]);
	return <></>;
};
